import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { ProductBadge } from "@dreamhub/designsystem/icons";

const ServiceEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-100 rounded-lg">
      <ProductBadge />
      <div className="flex flex-col items-center justify-center">
        <Text variant="body">{t("contractTerms.noServicesConfigured")}</Text>
        <Text variant="body" className="text-center">
          {t("contractTerms.noServicesConfiguredDescription")}
        </Text>
      </div>
    </div>
  );
};

export default ServiceEmptyState;
